<template>
    <div>
        <Loading v-bind:show="showLoadingAtivos">
            <PageTitle title="Benefícios - Ativos" />
            <Grid v-if="dadosAba && dadosAba.ativos  && $featureToggle.INTEGRA_BENEFICIO_ATIVOS"
                  v-bind:Data="dadosAba.ativos"
                  v-bind:Header="headerAtivos"
                  Name="ServicosAtivos"
                  Title="Ativos"
                  OrderBy="periodoLetivo"
                  v-bind:HeaderDetalhes="headerDetalheAtivos"
                  v-bind:DetalhesCombo1="dadosAba.situacao"
                  v-bind:DetalhesCombo2="dadosAba.periodo"
                  v-bind:DetalhesCombo3="null" />
        </Loading>

    </div>
</template>
<script>
    import Grid from '@/components/Grid';
    import Beneficio from '@/services/BeneficioService.js';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';

    export default {

        name: 'BeneficioAtivo',
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                  this.beneficioService = new Beneficio(this);
                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.BeneficioAtivo) {
                        this.dadosAba = a.Beneficios;
                    }
                    else {
                        this.showLoadingAtivos = true;
                        this.dadosAba = this.ativos();
                    }
                }
                else
                    this.$router.push('home');
            }

        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.BeneficioAtivo = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                showLoadingAtivos: false,
                headerAtivos: [
                    {
                        Titulo: "Período",
                        Field: "pelCod",
                        Width: "40px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Descrição",
                        Field: "descricaoCompleta",
                        Width: "200px",
                        Tipo: "texto"
                    },

                    {
                        Titulo: "Valor",
                        Field: "valor",
                        Width: "80px",
                        Tipo: "moeda"
                    },

                    {
                        Titulo: "Data Início",
                        Field: "dataInicioVigencia",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Fim",
                        Field: "dataTerminoVigencia",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Inclusão",
                        Field: "dataInclusao",
                        Width: "100px",
                        Tipo: "date"
                    }
                    ,
                    {
                        Titulo: "Status",
                        Field: "status",
                        Width: "80px",
                        Tipo: "texto"
                    }
                ],
                headerDetalheAtivos: [
                    {
                        Titulo: "Observação",
                        Field: "observacoes",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Usuário",
                        Field: "usuarioInclusao",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Tipo Lançamento",
                        Field: "descricaoTipoFluxo",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Data Baixa",
                        Field: "dtBaixa",
                        Tipo: "date"
                    }
                ],
                dadosAba: null
            }
        },
        methods: {
            ativos() {
                if (this.$featureToggle.INTEGRA_BENEFICIO_ATIVOS) {
                    this.showLoadingAtivos = true;
                    this.beneficioService.GetBeneficiosConcedidos({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        CodigoPeriodo: null,
                        CodigoEmpresa: this.aluno.codigoEmpresa
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAba = data.dados;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoadingAtivos = false;
                        });
                }
                else {
                    this.$modal.alert(this.$msgFeatureToggle);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
